import { Dispatch, SetStateAction } from 'react';
import Image from 'next/image';
import openEye from '../../../../public/assets/open-eye.svg';
import closedEye from '../../../../public/assets/closed-eye.svg';

interface EmptyParamsToggleButtonProps {
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  onToggle?: (isVisible: boolean) => void;
}

export function EmptyParamsToggleButton({
  isVisible,
  setIsVisible,
  onToggle,
}: EmptyParamsToggleButtonProps) {
  return (
    <div
      onClick={() => {
        const newState = !isVisible;
        setIsVisible(newState);
        onToggle?.(newState);
      }}
      className="flex items-center gap-1 text-[#012A38] font-inter text-[12px] font-normal cursor-pointer"
    >
      {isVisible ? (
        <>
          <Image src={openEye} alt="open_eye" />
          Hide Empty Fields
        </>
      ) : (
        <>
          <Image src={closedEye} alt="closed_eye" />
          Show All Fields
        </>
      )}
    </div>
  );
}
